import { Accordion as MuiAccordion, useTheme } from '@mui/material'

import { AccordionProps } from './Accordions.types'
import { SourceSiteDetails } from 'Features/OperationalPlanner/WorkcentreModal/WorkcentreModal.types'
import { AccordionSummary } from 'Features/OperationalPlanner/WorkcentreModal/AccordionSummary/AccordionSummary.view'
import { AccordionDetails } from 'Features/OperationalPlanner/WorkcentreModal/AccordionDetails/AccordionDetails.view'
import { isAnyWorkCentresSelected } from 'Features/OperationalPlanner/WorkcentreModal/WorkcentreModal.utils'

export const Accordions = ({
  sourceSiteDetails,
  handleCheckboxChange,
  readOnly,
}: AccordionProps) => {
  const theme = useTheme()

  const Accordion = (data: SourceSiteDetails) => {
    return (
      <MuiAccordion
        defaultExpanded={readOnly}
        key={data.siteKey}
        sx={{
          minWidth: '700px',
          border: `1px solid ${theme.palette.grey[300]}`,
          borderRadius: '3px',
          borderBottom: 'none',
          boxShadow: 'none',
          marginBottom: '10px',
          '&:before': {
            display: 'none',
          },
          '&.Mui-expanded': {
            margin: '10px 0px',
          },
        }}
      >
        <AccordionSummary
          readOnly={readOnly}
          sourceSiteData={data}
          handleCheckboxChange={handleCheckboxChange}
        />
        <AccordionDetails
          readOnly={readOnly}
          sourceSiteData={data}
          handleCheckboxChange={handleCheckboxChange}
        />
      </MuiAccordion>
    )
  }

  return (
    <>
      {sourceSiteDetails.map((data) =>
        readOnly
          ? isAnyWorkCentresSelected(data.siteWorkcentres)
            ? Accordion(data)
            : null
          : Accordion(data)
      )}
    </>
  )
}
